import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AdminShell } from '@/components/layout/admin-shell';
import { ROUTES } from '@/constants/routes';
import { meQueryOptions } from '@/hooks/data/use-auth';
import { isSuperAdmin } from '@/lib/roles';

export const Route = createFileRoute('/_authenticated/admin')({
  staticData: { title: 'Admin', hideAppShell: true },
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient
      .fetchQuery(meQueryOptions)
      .catch(() => null);

    if (!isSuperAdmin(user)) {
      // TanStack Router uses thrown non-Error redirects as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: ROUTES.DASHBOARD, replace: true });
    }
  },
  component: AdminRouteShell,
});

function AdminRouteShell(): React.ReactElement {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}
